(ns ductile.ui.agent.orchestration
  (:require [clojure.string :as str]))

(defn- normalize-intent-value
  [v]
  (cond
    (keyword? v) (name v)
    (string? v) v
    :else nil))

(defn- normalize-intent-keys
  [intent]
  (let [ks (or (:intent/keys intent) (:keys intent))]
    (->> ks
         (filter string?)
         (remove str/blank?)
         vec)))

(defn- key-str->kw
  [s]
  (when (string? s)
    (let [s (str/trim s)
          s (if (str/starts-with? s ":") (subs s 1) s)]
      (when (str/includes? s "/")
        (keyword s)))))

(defn service-intent?
  [intent]
  (let [domain (normalize-intent-value (or (:intent/domain intent) (:domain intent)))
        op (normalize-intent-value (or (:intent/operation intent) (:operation intent)))
        k (:recommended-key intent)]
    (and (map? intent)
         (= "services" domain)
         (#{"table" "list" "count" "exists"} op)
         (string? k)
         (not (str/blank? k)))))

(defn composite-intent?
  [intent]
  (let [policy (normalize-intent-value (or (:intent/policy intent) (:policy intent)))
        keys (normalize-intent-keys intent)
        exclusive? (if (contains? intent :intent/exclusive?)
                     (:intent/exclusive? intent)
                     (:exclusive? intent))]
    (and (= "combine-by-source" policy)
         (false? exclusive?)
         (seq keys))))

(defn service-intent-eval-code
  [intent]
  (let [k (:recommended-key intent)
        op (normalize-intent-value (or (:intent/operation intent) (:operation intent)))
        target (:target-service-code intent)]
    (case op
      "count"
      (str "(count (or (" k " data) []))")

      "exists"
      (if (and (string? target) (not (str/blank? target)))
        (str "(boolean (some #(= " (pr-str target) " (:service/code %)) (or (" k " data) [])))")
        (str "(boolean (seq (or (" k " data) [])))"))

      ;; default list/table representation for services
      (str "(->> (or (" k " data) []) "
           "(mapv #(select-keys % [:service/code :service/description])) "
           "(remove #(nil? (:service/code %))) "
           "(sort-by :service/code))"))))

(defn composite-intent-eval-code
  [intent]
  (let [keys (normalize-intent-keys intent)
        keys-kw (->> keys (keep key-str->kw) vec)
        facet-group (normalize-intent-value (or (:intent/facet-group intent) (:facet-group intent)))
        keys-str (pr-str keys-kw)
        facet-group (or facet-group "composite")]
    (str
     "(let [d (if (and (sequential? data) (= 1 (count data)) (map? (first data))) (first data) data)\n"
     "      ks " keys-str "\n"
     "      by-source (into {}\n"
     "                     (map (fn [k]\n"
     "                            (let [v (get d k)\n"
     "                                  non-empty? (if (coll? v) (boolean (seq v)) (some? v))\n"
     "                                  item-count (cond (coll? v) (count v) (nil? v) 0 :else 1)]\n"
     "                              [k {:non-empty? non-empty? :item-count item-count :value v}]))\n"
     "                          ks))]\n"
     "  {:facet-group " (pr-str facet-group) "\n"
     "   :non-empty? (boolean (some :non-empty? (vals by-source)))\n"
     "   :by-source by-source})")))
